import { FieldLabel, Stack } from 'braid-design-system';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';
import {
  StarSelector,
  type Rating,
} from '../../components/StarSelector/StarSelector';
import type { QuestionProps } from '../../type';

type RatingQuestionProps = QuestionProps<Rating> & {
  id: string;
  title: string;
  isRequired?: boolean;
};

export const RatingQuestion = ({
  id,
  title,
  value,
  message = '',
  isRequired = false,
  onChange,
}: RatingQuestionProps) => {
  const { t } = useTranslations(translations);
  return (
    <Stack space="small">
      <FieldLabel
        htmlFor={id}
        label={title}
        secondaryLabel={!isRequired ? t('Optional') : undefined}
      />

      <StarSelector
        id={id}
        onSelected={(value) => onChange(value)}
        value={value}
        message={message}
      />
    </Stack>
  );
};
